type PageHeaderType = {
  headerName?: string;
  description?: string;
  children?: React.ReactNode;
};

export default function PageHeader({
  headerName = "Prompt Library",
  description = "",
  children = null,
}: PageHeaderType) {
  return (
    <div>
      {/* ✅ Flexbox wrapper for icon + header */}
      <div
        className="h4 un_standard_color d-flex align-items-center gap-1"
        style={{ margin: 0 }}
      >
        {children}
        <span>{headerName}</span>
      </div>

      <p
        className="h5_400"
        style={{ fontWeight: 400, color: "var(--grey_tone)" }}
      >
        {description}
      </p>
    </div>
  );
}
